import * as React from 'react'

import { Box, Icon, Table, colors } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import TextField from 'modules/core/components/TextField'
import { Controls } from 'modules/core/hooks/usePaginatedQuery'
import i18n from 'modules/core/lib/i18n'

import { DEFAULT_ASSIGNMENT_PERCENTAGE } from 'modules/cost_centers/components/CostCenterAssigments/lib/defaults'
import DimensionValuePicker from 'modules/finance/components/Dimensions/SetAssignmentsPanel/DimensionValuePicker'
import { ValueOption } from 'modules/finance/components/Dimensions/SetAssignmentsPanel/DimensionValuePicker/Option'

import * as styles from './index.vanilla.css'

export type ValueAssignment = ValueOption & { percentage: number }

interface Props {
  placeholder?: string
  value: ValueAssignment
  options: ValueOption[]
  controls?: Controls
  withUnassignedPlaceholder?: boolean
  onDelete: (value: ValueOption) => void
  onChange: (valueId: string, newValue: ValueAssignment) => void
  onSearchChange: (search: string) => void
  loading?: boolean
  readonly?: boolean
}

const ValueRow = ({
  placeholder,
  value,
  options,
  controls,
  withUnassignedPlaceholder,
  onDelete,
  onChange,
  onSearchChange,
  loading,
  readonly,
}: Props) => {
  const [hover, setHover] = React.useState<boolean>(false)
  const hasNotPercentage = value.percentage == -1
  const notValid = !hasNotPercentage && (value.percentage <= 0 || value.percentage > 1)

  return (
    <Table.Row>
      <Table.Cell
        padding="s0"
        wide
        style={{
          ...(options.length === 0 && { backgroundColor: colors.grey200, cursor: 'pointer' }),
          background: readonly ? colors.grey200 : 'transparent',
        }}
      >
        <Box className={styles.borderlessSelector}>
          <DimensionValuePicker
            value={value}
            loading={loading}
            options={options}
            controls={controls}
            onChange={(v) => onChange(value.id, { ...v, percentage: value.percentage })}
            onSearchChange={onSearchChange}
            withUnassignedPlaceholder={withUnassignedPlaceholder}
            readonly={readonly}
            placeholder={
              placeholder ||
              i18n.t('finance.employee_dimensions_info.modals.set_assignments.select')
            }
          />
        </Box>
      </Table.Cell>
      <Table.Cell padding="s0" wide>
        <Box
          className={
            `${styles.borderlessInput}` + `${notValid ? ` ${styles.errorBorderlessInput}` : ''}`
          }
          justifyContent="center"
          height="full"
          border={{
            left: {
              width: 's1',
              style: 'solid',
              color: 'darker160',
            },
          }}
        >
          <TextField
            {...(!hasNotPercentage && { defaultValue: (value.percentage * 100).toFixed(2) })}
            onChange={(newAssignmet) => {
              onChange(value.id, {
                ...value,
                percentage:
                  newAssignmet === '' ? DEFAULT_ASSIGNMENT_PERCENTAGE : Number(newAssignmet) / 100,
              })
            }}
            type="number"
            min={0.0}
            readonly={readonly}
            step={'5'}
            placeholder={i18n.t(
              'finance.employee_dimensions_info.modals.set_assignments.default_value'
            )}
            isNotValid={notValid}
            onKeyDown={(e) => {
              if (e.key === '-') {
                e.preventDefault()
              }
            }}
            hideError
          />
        </Box>
      </Table.Cell>
      {!readonly && (
        <Table.Cell width={40} padding="s0">
          <Box
            paddingX="s8"
            paddingY="s12"
            background={hover ? 'grey300' : 'grey100'}
            alignItems="center"
            border={{
              left: {
                width: 's1',
                color: 'grey400',
                style: 'solid',
              },
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={() => onDelete(value)}
          >
            <Icon.Medium icon="delete" />
          </Box>
        </Table.Cell>
      )}
    </Table.Row>
  )
}

export default observer(ValueRow)
